import { useState } from 'react';
import { ExerciseActivityTargetClient, ExerciseActivityTargetDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useExerciseActivityTargetApi = () => {
    const apiClient = new ExerciseActivityTargetClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ExerciseActivityTargetDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createExerciseActivityTarget(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ExerciseActivityTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ExerciseActivityTargetDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateExerciseActivityTarget(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ExerciseActivityTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getExerciseActivityTargetById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ExerciseActivityTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchExerciseActivityTargets(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ExerciseActivityTargets');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteExerciseActivityTarget(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ExerciseActivityTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const downloadActivityTarget = async (id: string): Promise<string | undefined> => {
        setIsLoading(true);
        try {
            // This method will be available after API client regeneration
            const response = await apiClient.downloadActivityTarget(id);
            return response.data; // SAS URI
        } catch (err: any) {
            setError(err.message || 'Error generating activity target PDF');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, downloadActivityTarget, isLoading, error };
};